import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import auth from './modules/auth'
import contact from './modules/contact'
import otp from './modules/otp'
import patient from './modules/patient'
import notification from './modules/notification'
import medicineColor from './modules/medicine-color'
import medicineShortcut from './modules/medicine-shortcut'
import survey from './modules/survey'
import homeCareBook from './modules/home-care-book'
import app from './modules/app'
import medicine from './modules/medicine'
import maintenance from './modules/maintenance'

Vue.use(Vuex)

const vuexPersistLocal = new VuexPersist({
  storage: localStorage,
  reducer: (state) => ({
    auth: {
      access_token: state.auth.access_token,
      token: state.auth.token,
      refreshToken: state.auth.refreshToken,
      doctorInfo: state.auth.doctorInfo,
      fcmToken: state.auth.fcmToken,
      rememberMe: state.auth.rememberMe,
      typeOfUser: state.auth.typeOfUser,
      emailChange: state.auth.emailChange
    },
    contact: {
      contact: state.contact.contact
    },
    otp:{
      otpAccessToken: state.otp.otpAccessToken,
      otpLoading: state.otp.otpLoading,
      otpCode: state.otp.otpCode,
      childId: state.otp.childId
    },
    patient:{
      info: state.patient.info,
      pdf: state.patient.pdf,
      seizures: state.patient.seizures,
      basic_info: state.patient.basic_info
    },
    homecare: {
      base: state.homeCareBook.base,
      homecarePdf: state.homeCareBook.homecarePdf,
      vaccinPdf: state.homeCareBook.vaccinPdf,
      allergyPdf: state.homeCareBook.allergyPdf,
    },
    notification: {
      notification: state.notification.notification,
      lastUpdate: state.notification.lastUpdate
    },
    survey: {
      survey_id: state.survey.survey_id,
      banner_redirect_url: state.survey.banner_redirect_url,
      survey_thank_page_url: state.survey.survey_thank_page_url,
      banner_image_url: state.survey.banner_image_url,
      survey_start_date: state.survey.survey_start_date,
      survey_end_date: state.survey.survey_end_date,
      errorMsg: state.survey.errorMsg,
      surveyComplete: state.survey.surveyComplete
    },
    medicine: {
      medicines: state.medicine.medicines
    },
    app: {
      isSupportServiceWorker: state.app.isSupportServiceWorker
    },
    maintenance: {
      isMaintenance: state.maintenance.isMaintenance,
      maintenanceData: state.maintenance.maintenanceData
    }
  })
})

export default new Vuex.Store({
  modules: {
    auth,
    contact,
    otp,
    patient,
    notification,
    medicineColor,
    medicineShortcut,
    survey,
    homeCareBook,
    medicine,
    app,
    maintenance,
  },
  plugins: [vuexPersistLocal.plugin]
})
